import { useDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import accountListReducer, { accountList } from './accountListSlice';
import contentReducer, { content } from './contentSlice';
import headerReducer, { header } from './headerSlice';
import sessionReducer, { session } from './sessionSlice';
import refreshReducer, { refresh } from './refreshSlice';
import logoutReducer, { logout } from './logoutSlice';
import featureReducer, { feature } from './featureSlice';
import appStateReducer, { appState } from './appStateSlice';
import accountToWalletReducer, { addToWallet } from './addToWalletSlice';
import creditLimitIncreaseReducer, {
  creditLimitIncrease,
} from './creditLimitIncreaseSlice';
import customerVerificationFormReducer, {
  customerVerificationForm,
} from './customerVerificationFormSlice';
import paymentTokenReducer, { paymentToken } from './paymentTokenSlice';
import termsAndConditionsReducer, {
  termsAndConditions,
} from './termsAndConditionsSlice';

export const store = configureStore({
  reducer: {
    [appState]: appStateReducer,
    [accountList]: accountListReducer,
    [content]: contentReducer,
    [header]: headerReducer,
    [session]: sessionReducer,
    [refresh]: refreshReducer,
    [logout]: logoutReducer,
    [feature]: featureReducer,
    [customerVerificationForm]: customerVerificationFormReducer,
    [addToWallet]: accountToWalletReducer,
    [paymentToken]: paymentTokenReducer,
    [creditLimitIncrease]: creditLimitIncreaseReducer,
    [termsAndConditions]: termsAndConditionsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// @see https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
export type AppDispatch = typeof store.dispatch;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types
